/**
 * Cheelee Public API Docs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetCurrencyPairsByTsRespResult } from './getCurrencyPairsByTsRespResult';


export interface GetCurrencyPairsByTsResp { 
    jsonrpc?: GetCurrencyPairsByTsResp.JsonrpcEnum;
    id?: number;
    result?: GetCurrencyPairsByTsRespResult;
}
export namespace GetCurrencyPairsByTsResp {
    export type JsonrpcEnum = '2.0';
    export const JsonrpcEnum = {
        _20: '2.0' as JsonrpcEnum
    };
}


